export default "__VITE_ASSET__af04803c__"